export default __webpack_public_path__ + "static/media/liquid-figure-min.cc421d89.png";